import { Pipe, PipeTransform, Inject } from '@angular/core';
import { ITranslationService, I18NEXT_SERVICE } from 'angular-i18next';
import { ERROR_TYPE, ErrorResponse } from '../../core';
import { ValidationErrors, Validators } from '@angular/forms';

const VALIDATOR_PREFIX = 'VALIDATOR.';
const I18N_PREFIX = 'errors:';

@Pipe({
  name: 'validatorMessage',
})
export class ValidatorMessagePipe implements PipeTransform {
  constructor(@Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService) {}

  transform(error: ErrorResponse | ValidationErrors, field: string, prefix?: string): string;
  transform(error: ErrorResponse | ValidationErrors, field: string, validators?: string[], prefix?: string): string;
  transform(
    error: ErrorResponse | ValidationErrors,
    field: string,
    validators?: string[] | string,
    prefix?: string
  ): string {
    if (typeof validators === 'string') {
      prefix = validators;
      validators = undefined;
    }

    if (!error) {
      return null;
    }

    let message: string = null;
    let transKeys: string[] = [];

    if (error instanceof ErrorResponse || error.type) {
      switch (error.type) {
        case ERROR_TYPE.VALIDATOR:
          if (!error.errors[field]) {
            break;
          }

          const validatorKey = error.errors[field].validator;
          if (prefix) {
            transKeys = transKeys.concat([
              `${I18N_PREFIX}${VALIDATOR_PREFIX}${prefix}.${field}.${validatorKey}`,
              `${I18N_PREFIX}${VALIDATOR_PREFIX}${prefix}.${field}`,
              `${I18N_PREFIX}${VALIDATOR_PREFIX}${prefix}.${validatorKey}`,
            ]);
          }
          transKeys = transKeys.concat([
            `${I18N_PREFIX}${VALIDATOR_PREFIX}${field}.${validatorKey}`,
            `${I18N_PREFIX}${VALIDATOR_PREFIX}${field}`,
            `${I18N_PREFIX}${VALIDATOR_PREFIX}${validatorKey}`,
          ]);
          message = this.getCustomFieldMessage(
            field,
            transKeys,
            {
              ...error.value,
              ...error.errors[field].value,
            },
            error.errors[field].message
          );
          break;
        case ERROR_TYPE.SERVICE:
          if (!validators || !validators.includes(error.code)) {
            break;
          }
          if (prefix) {
            transKeys = transKeys.concat([`${I18N_PREFIX}${prefix}.${error.code}`]);
          }
          transKeys = transKeys.concat([error.code]);
          message = this.getCustomFieldMessage(field, transKeys, error.value, error.message);
          break;
      }
    } else {
      const validatorKeys = Object.keys(error);
      if (prefix) {
        transKeys = transKeys.concat(
          validatorKeys.map((k) => `${I18N_PREFIX}${VALIDATOR_PREFIX}${prefix}.${field}.${k}`),
          [`${I18N_PREFIX}${VALIDATOR_PREFIX}${prefix}.${field}`],
          validatorKeys.map((k) => `${I18N_PREFIX}${VALIDATOR_PREFIX}${prefix}.${k}`)
        );
      }
      transKeys = transKeys.concat(
        validatorKeys.map((k) => `${I18N_PREFIX}${VALIDATOR_PREFIX}${field}.${k}`),
        [`${I18N_PREFIX}${VALIDATOR_PREFIX}${field}`],
        validatorKeys.map((k) => `${I18N_PREFIX}${VALIDATOR_PREFIX}${k}`)
      );

      const context = typeof error[validatorKeys[0]] === 'object' ? error[validatorKeys[0]] : {};
      message = this.getCustomFieldMessage(field, transKeys, {});
    }
    return message;
  }

  getCustomFieldMessage(
    field: string,
    transKeys: string[],
    context?: object | any,
    defaultMessage?: string
  ): string | null {
    let message = null;
    transKeys.some((k) => {
      if (this.i18NextService.exists(k, context) === true) {
        const m = this.i18NextService.t(k, context);
        if (m && typeof m === 'string') {
          console.log('-- ValidatorMessagePipe : ', k, m);
          message = m;
          return true;
        } else {
          console.log('-- ValidatorMessagePipe not : ', m);
        }
      }
      return false;
    });
    console.log(
      '--- ControlErrorsDirective : displayErrorMessage : ',
      field,
      transKeys,
      context,
      message,
      defaultMessage
    );

    return message ? message : defaultMessage;
  }
}
